import { Button, Dropdown, IconPlusCircle, Tooltip, useDropdownState, Wrapper } from '@screentone/core';

import { BlockDividerButton } from 'components/block-divider-button/BlockDividerButton';
import { useStructureEditContext } from 'contexts/structure-edit/StructureEditContext';
import styles from './AddModuleButton.module.scss';

interface AddModuleButtonProps {
  groupId: string | null;
  insertIndex?: number;
}

export const AddModuleButton = ({ groupId, insertIndex }: AddModuleButtonProps) => {
  const { open, setOpen, componentRef } = useDropdownState();
  const { getAvailableModulesForGroup, addNewModule } = useStructureEditContext();

  const options = getAvailableModulesForGroup(groupId);

  const handleAddModule = (treatmentType: string) => {
    addNewModule(groupId, treatmentType, insertIndex);
    setOpen(false);
  };

  if (options.length === 0) {
    return null;
  }

  return (
    <BlockDividerButton open={open}>
      <Dropdown
        open={open}
        position="center"
        onToggle={() => setOpen(!open)}
        componentRef={componentRef}
        padding={{ all: 'none' }}
        data-testid="add-module-button"
      >
        <Dropdown.Trigger>
          <Tooltip>
            <Tooltip.Content position="right">Add module</Tooltip.Content>
            <Tooltip.Trigger>
              <Button tertiary icon={IconPlusCircle} onClick={() => setOpen(!open)} />
            </Tooltip.Trigger>
          </Tooltip>
        </Dropdown.Trigger>
        <Dropdown.Content className={styles.blockDividerDropdownContent}>
          <Wrapper padding={{ all: 'md' }}>
            {options.map(({ treatmentType, label }) => (
              <Button
                key={treatmentType}
                tertiary
                fullWidth
                className={styles.moduleButton}
                onClick={() => handleAddModule(treatmentType)}
                data-testid="page-add-module-button"
              >
                <span className={styles.moduleOption}>
                  <span>{label !== treatmentType ? label : treatmentType}</span>
                  {label !== treatmentType && <span className={styles.moduleOptionKey}>{treatmentType}</span>}
                </span>
              </Button>
            ))}
          </Wrapper>
        </Dropdown.Content>
      </Dropdown>
    </BlockDividerButton>
  );
};
